// src/components/About.js
import React from "react";
import { FaInstagram, FaFacebook, FaTwitter } from "react-icons/fa";
import InstructorImage from "../assets/instructor.jpg";
import InstructorImage2 from "../assets/instructor2.jpg";
import InstructorVideo from "../assets/instructor.mp4";
import Offerings from "../components/Offerings";
import { useNavigate } from "react-router-dom";
import PricingCard from "../components/PricingCard";
import TestimonialCarousel from "../components/TestimonialCarousel";

const About = () => {
  const navigate = useNavigate();
  const handleOfferinsButtonClick = () => {
    navigate("/offerings");
  };
  const handleCollaborationsButton = () => {
    navigate("/collaborations");
  }
  const handleBookButtonClick = () => {
    navigate("/book-class");
  }
  return (
    <div>
      {/* Section 1: About - Yogic Background */}
      <div className="about-section">
        <div className="black-overlay"></div>
        <div className="about-text">
          <h1>Rooted in tradition, refreshed for today.</h1>
          <p>
            Asanas, timeless wisdom and heartfelt stories - come breathe with
            me. Namaste!
          </p>
          <div>
            <button className="primary-button btn-lg" onClick={handleBookButtonClick}>
              Ready to register?
            </button>
            <button className="secondary-button btn-lg" onClick={handleCollaborationsButton}>
              Our Collaborations
            </button>
          </div>
          <img
            src={InstructorImage}
            alt="Instructor"
            className="instructor-image"
          />
        </div>
      </div>

      <div class="floating-message">
        <div
          onClick={handleBookButtonClick}
        >
          Free class for first timers, claim yours now!
        </div>
      </div>

      {/* Section 1: Query or Teach with Us */}
      <div className="query-teach-section">
        <h3>Have a query? or Interested in teaching with us?</h3>
        <p>
          Drop us an email at{' '}
          <a href="mailto:viksityoga@gmail.com" className="mail-link">
            viksityoga@gmail.com
          </a>
        </p>
      </div>

      {/* Section 2: Patanjali Quote */}
      <div className="quote-section">
        <h2>योगश्चित्तवृश्चत्तश्चनरोधः</h2>
        <p>Yogah chitta vritti nirodhaḥ ||1:2||</p>
        <p>
          Restraining the modulations of the mind is Yoga. ---Maharishi
          Patanjali
        </p>
      </div>

      {/* Section 5: Book Class */}
      <div
        className="book-class-section"
        style={{ padding: "2rem", textAlign: "center" }}
      >
        <h2>Book a 45 min Yoga Class</h2>
        {/* <PricingCard /> */}
        <p>Click below to book a class with us:</p>
        {/* <a
          href="https://calendly.com/viksityoga/45minyogaclass"
          target="_blank"
          rel="noopener noreferrer"
        > */}
          <button className="primary-button" onClick={handleBookButtonClick}>Book Now</button>
        {/* </a> */}
      </div>

      {/* Section 3: Our Offerings */}
      <div className="course-offerings">
        <Offerings isFullList={false} />
        <button
          className="primary-button full-list-btn"
          onClick={handleOfferinsButtonClick}
        >
          View full list
        </button>
      </div>

      <div className="testimonial-section">
        <TestimonialCarousel />
      </div>

      {/* Section 2: Know Your Instructor */}
      <div className="instructor-section">
        <div className="instructor-wrapper">
          <div className="instructor-image-wrapper">
            <img
              src={InstructorImage2}
              alt="Instructor"
              className="instructor-image-large"
            />
          </div>
          <div className="instructor-description">
            <h2>Know Your Instructor</h2>
            <p>
              Three years ago, I embarked on a transformative yoga journey. When
              I moved to the US, I was immediately drawn to yoga classes. Like
              many, I initially thought yoga was just about relaxation and
              gentle stretches. However, my first class shattered that
              perception!
            </p>
            <p>
              The intensity and movement of the practice opened up neglected
              parts of my body, bringing a profound sense of calm and clarity.
              As I continued to practice, I experienced a personal evolution —
              both physically and mentally. The more I practiced, the more
              passionate I became about teaching yoga.
            </p>
            <p>
              I decided to pursue a yoga instructor course, and the 8-week
              journey was nothing short of magical. It deepened my understanding
              of the theory and practice of yoga, and also offered me invaluable
              wisdom on the path to self-realization.
            </p>
            <p>
              I am deeply grateful for the support from my loved ones, my
              incredible instructors, and the universe itself. As I continue to
              walk this path, I invite you to join me in this transformative
              journey. Let’s connect, breathe, and grow together. Namaste!
            </p>
            <p class="instructor-association">
              I am also associated with Yoga Alliance as a 200R Yoga
              Instructor, check out my profile here:
              <a
                href="https://r.yogaalliance.org/TeacherPublicProfile?tid=376731"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Yoga Alliance 200R{" "}
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Section 3: Instructor Videos */}
      <div className="video-section">
        <div className="video-container">
          <video
            className="video-player"
            autoPlay
            loop
            muted
            controls
            width="100%"
            height="500px"
          >
            <source src={InstructorVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* Section 6: Social Media */}
      <div className="social-section">
        <h2>Follow Us on Social Media</h2>
        <div className="social-icons">
          <a
            href="https://www.instagram.com/viksit_yoga/profilecard/?igsh=MWhtZTR6M205OW5nbQ=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          {/* <a
            href="https://facebook.com/yourhandle"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://twitter.com/yourhandle"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter />
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default About;
